import {
  requestChangeStatusManyTeamRegister
} from 'app/api/event'
import { RegisterTeamActivityStatus } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import {
  ILocation,
  ITeam,
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { notificationController } from 'app/controllers/notification-controller'
import { EventKeys } from 'app/react-query/query-key/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef, useState } from 'react'
import { useQueryClient } from 'react-query'

export const ModalApproveManyTeam = ({
  locations,
  teams,
}: {
  locations?: ILocation[]
  teams: ITeam[]
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const refModal = useRef<IRefModal>({})

  const [form] = BaseForm.useForm<{ reason?: string }>()

  const query = useQueryClient()
  const [isLoadingApprove, setIsLoadingApprove] = useState(false)

  const onPressApprove = async () => {
    if (!user?.member?.id) return

    try {
      setIsLoadingApprove(true)
      const res = await requestChangeStatusManyTeamRegister(
        teams?.map(team => ({
          id: team?.id ?? 0,
          status: RegisterTeamActivityStatus.ACCEPTED,
          approvedById: +(user?.member?.id ?? 0),
          locationIds: locations?.map(itm => `${itm?.id ?? 0}`),
        })) ?? [],
      )

      if (res) {
        query.invalidateQueries({
          queryKey: EventKeys.allListActionNotJoinByTeam,
        })
        query.invalidateQueries({
          queryKey: EventKeys.allListActionRegisteredByTeam,
        })

        notificationController?.success({ message: 'Đã phê duyệt!' })
        refModal?.current?.hide?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoadingApprove(false)
    }
  }

  const handleSubmit = async () => {
    await onPressApprove()
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Phê duyệt tất cả đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Phê duyệt tất cả"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoadingApprove}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText
              children={`Bạn có chắc chắn phê duyệt tất cả đơn đăng ký này?`}
              fontWeight="medium"
              fontSize="xs"
            />
            <BaseText
              children={`Lưu ý: Sau khi phê duyệt, bạn có thể thay đổi trạng thái của đoàn viên trong hoạt động`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
